const SelectMyDashboardMenu = ({
  setOpenSelectGraphSlider,
  setEditSelectGraphShow,
  openAlertScreen,
  openDownloadScreen,
  setOpenDashboardListSlider
}) => {
  const pathSegments = window.location.pathname.split('/');
  const isEditMode = pathSegments.includes('viewDashboardList'); // or however you determine editMode

  return (
    <div>
      {/* Sidebar dropdown */}
      <div className="daz-sidebar__hoverinfo shadow">
        {/* Select Graphs */}
        <div className="daz-sidebar__dropdown--item">
          <div
            className={`daz-sidebar__hoverinfo--click ${isEditMode ? 'disabled-option' : ''}`}
            onClick={() => {
              if (isEditMode) return; // Prevent action in edit mode
              setOpenSelectGraphSlider(true);
              setEditSelectGraphShow(false);
              openAlertScreen('close_slider');
              openDownloadScreen('close_slider');
            }}
            style={{ cursor: isEditMode ? 'not-allowed' : 'pointer', opacity: isEditMode ? 0.5 : 1 }}
          >
            Select Graphs
          </div>
        </div>

        {/* Saved Dashboard */}
        <div className="daz-sidebar__dropdown--item">
          <div
            className="daz-sidebar__hoverinfo--click"
            onClick={() => {
               if (isEditMode) return;    
              setOpenDashboardListSlider(true);
              openAlertScreen('close_slider');
              openDownloadScreen('close_slider');
              setOpenSelectGraphSlider(false);
            }}
              style={{ cursor: isEditMode ? 'not-allowed' : 'pointer', opacity: isEditMode ? 0.5 : 1 }}
          >
            Saved Dashboard
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectMyDashboardMenu;
